import { render, staticRenderFns } from "./DocumentInsertionSupplier.vue?vue&type=template&id=4e0507e2&"
import script from "./DocumentInsertionSupplier.vue?vue&type=script&lang=ts&"
export * from "./DocumentInsertionSupplier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports